"use strict";

var _toConsumableArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/toConsumableArray.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileType = exports.ASSET_FIELD = void 0;
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _createPreviewGetter = _interopRequireDefault(require("../preview/createPreviewGetter"));
var _utils = require("./utils");
var _constants = require("./constants");
var _excluded = ["name"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var ASSET_FIELD = {
  name: 'asset',
  type: 'reference',
  to: {
    type: 'sanity.fileAsset'
  }
};
exports.ASSET_FIELD = ASSET_FIELD;
var OVERRIDABLE_FIELDS = _toConsumableArray(_constants.DEFAULT_OVERRIDEABLE_FIELDS);
var FILE_CORE = {
  name: 'file',
  type: null,
  jsonType: 'object'
};
var DEFAULT_OPTIONS = {
  accept: ''
};
var FileType = {
  get: function get() {
    return FILE_CORE;
  },
  extend: function extend(subTypeDef, extendMember) {
    var options = _objectSpread({}, subTypeDef.options || DEFAULT_OPTIONS);
    var fields = (subTypeDef.fields || []).concat([ASSET_FIELD]).filter(Boolean);
    var parsed = Object.assign((0, _pick2.default)(FILE_CORE, OVERRIDABLE_FIELDS), subTypeDef, {
      type: FILE_CORE,
      options: options,
      isCustomized: Boolean(subTypeDef.fields)
    });
    (0, _utils.lazyGetter)(parsed, 'fields', function () {
      return fields.map(function (fieldDef) {
        var name = fieldDef.name,
          type = _objectWithoutProperties(fieldDef, _excluded);
        return {
          name: name,
          type: extendMember(type)
        };
      });
    });
    (0, _utils.lazyGetter)(parsed, 'preview', (0, _createPreviewGetter.default)(Object.assign({}, subTypeDef, {
      fields: fields
    })));
    return subtype(parsed);
    function subtype(parent) {
      return {
        get: function get() {
          return parent;
        },
        extend: function extend(extensionDef) {
          if (extensionDef.fields) {
            throw new Error('Cannot override `fields` of subtypes of "file"');
          }
          var current = Object.assign({}, parent, (0, _pick2.default)(extensionDef, OVERRIDABLE_FIELDS), {
            type: parent
          });
          return subtype(current);
        }
      };
    }
  }
};
exports.FileType = FileType;